import React from 'react'

export const Code = (props) => {
  return (
    <div id="code" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Get the Code</h2>
          <p>
            The developed algorithm is available for experimentation or
            analysis. You can run the original Python scripts using Jupyter
            Notebooks or you can run a Python Flask implementation of the
            algorithm to generate proteins using a GUI.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-6 col-sm-6 code">
                  <div className="thumbnail">
                    {' '}
                    <a href={d.link}>
                      <img src={d.img} alt="..." className="code-img" />

                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                      </div>
                    </a>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
